import { AbstractControl, ValidationErrors } from '@angular/forms';

export const EAN13_LENGTH = 13;
export const MAX_SHORT_BARCODE_LENGTH = 12;

export function isValidEAN13(barcode: string): boolean {
  if (barcode.length !== EAN13_LENGTH) {
    return false;
  }
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const digit = parseInt(barcode[i], 10);
    sum += i % 2 === 0 ? digit : digit * 3;
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === parseInt(barcode[12], 10);
}

/** Accepts empty, short internal codes (1–12 digits), or valid EAN-13. Rejects 14+ digits and bad checksums. */
export function barcodeValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const barcode = control.value.toString().trim();
  if (!barcode) {
    return null;
  }
  if (!/^\d+$/.test(barcode)) {
    return { invalidBarcode: { message: 'Barcode must contain digits only' } };
  }
  if (barcode.length > EAN13_LENGTH) {
    return {
      invalidBarcode: {
        message: `Barcode must be EAN-13 (${EAN13_LENGTH} digits) or a short internal code (up to ${MAX_SHORT_BARCODE_LENGTH} digits)`
      }
    };
  }
  if (barcode.length === EAN13_LENGTH && !isValidEAN13(barcode)) {
    return { invalidBarcode: { message: 'Invalid EAN-13 barcode checksum' } };
  }
  return null;
}

export function extractApiErrorMessage(err: any, fallback: string): string {
  return err?.error?.response?.message
    || err?.error?.message
    || err?.message
    || fallback;
}

export function isApiSuccess(res: any): boolean {
  return res?.response?.success === true;
}
